// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main_3Rgm5","top-blank":"index_top-blank_2EoXh","bottom-blank":"index_bottom-blank_1uV8P","content":"index_content_3EMpy","page":"index_page_jNyqk"};